<div class="content" *ngIf="permissionSet$ | async as permissionSet; else loading">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Permission Set Details : {{ permissionSet.name }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#!"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item" [routerLink]="eps.permissionSet.permissionSetPath">
            Permission Set
          </li>
          <li class="breadcrumb-item active" aria-current="page">Permission Set Details</li>
        </ol>
      </nav>
    </div>
    <div
      class="d-flex my-xl-auto right-content align-items-center flex-wrap"
      *appHasPermission="{ permissionSet: ['edit'] }"
    >
      <div class="me-2 mb-2">
        <button
          (click)="openModel(assignUsersModal)"
          class="btn btn-primary"
          type="button"
          *ngIf="permissionSet.name !== 'Admin'"
        >
          Assign Users
        </button>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="card">
      <div class="card-body">
        <div class="pb-3 d-flex justify-content-between">
          <h3>Manage Assignments</h3>
        </div>
        <div class="row">
          <div class="custom-datatable-filter table-responsive">
            <ng-container *ngIf="assignedTo$ | async as assignedTo">
              <ng-container *ngIf="assignedTo.length > 0; else noRecords">
                <table class="table datatable" *ngIf="assignedTo.length > 0">
                  <thead class="thead-light">
                    <tr>
                      <th>Name</th>
                      <th>Valid Upto</th>
                      <th>Business Entity</th>

                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let assignment of assignedTo$ | async">
                      <td>
                        <div class="d-flex align-items-center">
                          <a
                            [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                            class="avatar avatar-md"
                            data-bs-toggle="modal"
                            data-bs-target="#view_details"
                          >
                            <!-- <img
                              [src]="
                                assignment.user.picture
                                  ? apiEndpoint + assignment.user.picture
                                  : defaultImg
                              "
                              class="img-fluid rounded-circle"
                              alt="img"
                            /> -->
                            <ng-container *ngIf="assignment.user.picture; else initials">
                              <img
                                [src]="apiEndpoint + '/uploads/' + assignment.user.picture"
                                class="rounded-circle border border-2"
                                alt="img"
                              />
                            </ng-container>

                            <ng-template #initials>
                              <span
                                class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                                style="width: 35px; height: 35px"
                                >{{
                                  getInitials(assignment.user.firstName, assignment.user.lastName)
                                }}</span
                              >
                            </ng-template>
                          </a>
                          <div class="ms-2">
                            <p class="text-dark mb-0">
                              <a [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                                >{{ assignment.user.firstName | capitalize }}
                                {{ assignment.user.lastName | capitalize }}</a
                              >
                            </p>
                          </div>
                        </div>
                      </td>

                      <td>
                        <span class="d-inline-flex align-items-center">
                          <span *ngIf="!(idForValidUptoUpdate === assignment.id)">
                            {{ assignment.validUpto | date: 'MMM d, yyyy h:mm a' }}
                          </span>

                          <div
                            *ngIf="idForValidUptoUpdate === assignment.id"
                            class="d-inline-flex align-items-center"
                          >
                            <input
                              appTrimInput
                              type="datetime-local"
                              [ngModel]="formatForDateTimeLocal(assignment.validUpto)"
                              (ngModelChange)="TempValidUpto = $event"
                              class="form-control me-2"
                              style="width: auto"
                            />
                            <button class="btn btn-success btn-sm me-2" (click)="saveValidUpto()">
                              <i class="ti ti-check"></i>
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              (click)="(idForValidUptoUpdate = '') && (TempValidUpto = null)"
                            >
                              x
                            </button>
                          </div>
                        </span>
                      </td>

                      <td>
                        {{ assignment.user.business?.businessName || '-' }}
                      </td>

                      <td class="text-end">
                        <div class="action-icon d-inline-flex">
                          <ng-container *appHasPermission="{ permissionSet: ['edit'] }">
                            <button
                              type="button"
                              class="btn btn-icon-style p-1 m-1"
                              *ngIf="!idForValidUptoUpdate"
                              (click)="editValidUpto(assignment.id)"
                              aria-label="Delete item"
                              data-bs-toggle="tooltip"
                              title="Update"
                            >
                              <i class="ti ti-edit"></i>
                            </button>
                          </ng-container>
                          <ng-container *appHasPermission="{ permissionSet: ['delete'] }">
                            <!-- <button
                              type="button"
                              class="btn btn-icon-style p-1 m-1"
                              *ngIf="!idForValidUptoUpdate"
                              (click)="deleteAssignment(assignment.id)"
                              aria-label="Delete item"
                              data-bs-toggle="tooltip"
                              title="Delete"
                            > -->
                            <button
                              type="button"
                              class="btn btn-icon-style p-1 m-1"
                              *ngIf="!idForValidUptoUpdate"
                              (click)="openDeleteModal(assignment.id)"
                              aria-label="Delete item"
                              data-bs-toggle="tooltip"
                              title="Delete"
                            >
                              <i class="ti ti-trash" aria-hidden="true"></i>
                            </button>
                          </ng-container>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </ng-container>
            <ng-template #noRecords>
              <div class="text-center">Record not available</div>
            </ng-template>
          </div>
          <!-- pagination -->
          <ng-container *ngIf="assignedTo$ | async as assignedTo">
            <ng-container *ngIf="assignedTo.length > 0">
              <div
                class="d-flex align-items-center justify-content-between ms-2"
                *ngIf="assignedTo.length > 0"
              >
                <div>
                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                  {{ totalCount }} entries
                </div>
                <div class="has-text-centered mt-3">
                  <app-pagination
                    [currentPage]="currentPage"
                    [pageSize]="pageLimit"
                    [totalRows]="totalCount"
                    (pageChange)="pageChanged($event)"
                  ></app-pagination>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assign Users Modal -->
<ng-template #assignUsersModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Assign Users</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div
    class="modal-body"
    style="padding: 0; display: flex; flex-direction: column; max-height: 70vh"
  >
    <div class="table-scroll-area" style="flex: 1; overflow-y: auto; padding: 1rem">
      <form *ngIf="permissionSet$ | async as permissionSet">
        <label class="form-label" for="businessIdtoAssign" *ngIf="false">Assigned To</label>
        <ng-select
          *ngIf="false"
          class="me-3 w-100 mb-2"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessIdtoAssign"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <!-- <label class="form-label" for="businessId">Assigned From</label>
        <ng-select
          class="me-3 w-100 mb-2"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessId"
          (change)="onIsStandardChange()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select> -->
        <ng-container *ngIf="unassignedUsers$ | async as unassignedUsers">
          <!-- 🔍 Search Box -->
          <div class="mb-3">
            <input
              appTrimInput
              type="text"
              class="form-control"
              placeholder="Search users by name..."
              [(ngModel)]="searchText"
              name="searchText"
            />
          </div>

          <table
            *ngIf="filteredUsers(unassignedUsers).length > 0; else noRecords"
            class="table datatable"
          >
            <thead class="thead-light">
              <tr>
                <th>Select</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of filteredUsers(unassignedUsers)">
                <td>
                  <input
                    appTrimInput
                    type="checkbox"
                    [value]="user.id"
                    (change)="toggleSelection(user)"
                  />
                </td>
                <td class="d-flex">
                  <a [routerLink]="[eps.hrm.employeePath, user.id]" class="avatar avatar-md me-2">
                    <!-- <img
                      [src]="user.picture ? apiEndpoint + '/uploads/' + user.picture : defaultImg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    /> -->
                    <ng-container *ngIf="user.picture; else initials">
                      <img
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 35px; height: 35px"
                        >{{ getInitials(user.firstName, user.lastName) }}</span
                      >
                    </ng-template>
                  </a>
                  <span>
                    <!-- <a [routerLink]="[eps.hrm.employeePath, user.id]">{{
                      user.firstName | capitalize
                    }}</a> -->
                    {{ user.firstName | capitalize }} {{ user.lastName | capitalize }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>

        <ng-template #noRecords>
          <div class="text-center text-muted py-4">No records available</div>
        </ng-template>
      </form>
    </div>

    <div class="modal-footer" style="padding: 1rem">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary wizard-next-btn"
        [disabled]="selectedUsers.length === 0"
        (click)="saveAssignedUsers()"
      >
        Add
      </button>
    </div>
  </div>
</ng-template>

<!-- /Assign Users Modal -->

<ng-template #loading>
  <!-- <p>Loading business details...</p> -->
  <app-loader></app-loader>
</ng-template>
